import { render, staticRenderFns } from "./MoreUserInfo.vue?vue&type=template&id=33b761f3&"
import script from "./MoreUserInfo.vue?vue&type=script&lang=ts&"
export * from "./MoreUserInfo.vue?vue&type=script&lang=ts&"
import style0 from "./more_user_info.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports